const style1 = {
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width:" 100%",
    maxWidth:"367px"
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = {
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = {
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"128.0654% 0 0 0",
    width:"100%"
}
const style5 = {
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function FranklinBenjaminAltEmbed(){
    return (
        <>
        <div class="getty embed image" style={style1}><div style={style2}><a href="https://www.gettyimages.com/detail/1454700925" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/1454700925?et=amNEC9ivSNJh3Pm5bxBEfg&tld=com&sig=z9Re2o5PxiQh8YeWXCjxUGLvlLKp--2jDP7jGUbw7JE=&caption=true&ver=1" title="Benjamin Franklin" scrolling="no" frameBorder="0" width="367" height="470" style={style5}></iframe></div></div>
        </>
    );
};
export default FranklinBenjaminAltEmbed;